import { CART_EMPTIED_EVENT, CART_EXPIRED_EVENT } from '../Service/CartService'
import { getElement } from '../Utility/Dom'

interface Copy {
  text: string
  title: string
}

class CartExpiredModal {
  private readonly closeButton: HTMLElement | null
  private readonly dialog: HTMLDialogElement | null
  private readonly emptiedCopy: Copy
  private readonly expiredCopy: Copy
  private readonly stayButton: HTMLElement | null
  private readonly text: HTMLElement | null
  private readonly title: HTMLElement | null

  constructor() {
    this.dialog = getElement('cart-expired-modal') as HTMLDialogElement | null
    this.closeButton = getElement('cart-expired-close')
    this.stayButton = getElement('cart-expired-stay')
    this.title = getElement('cart-expired-title')
    this.text = getElement('cart-expired-text')

    // The partial renders the expiry wording, so it is the baseline the emptied copy falls back to.
    this.expiredCopy = {
      text: this.text?.textContent ?? '',
      title: this.title?.textContent ?? '',
    }
    this.emptiedCopy = {
      text: this.dialog?.dataset.textEmpty ?? '',
      title: this.dialog?.dataset.titleEmpty ?? '',
    }
  }

  init(): void {
    if (this.dialog === null) return
    this.addEvents()
  }

  private addEvents(): void {
    document.addEventListener(CART_EXPIRED_EVENT, (): void => this.show(this.expiredCopy))
    document.addEventListener(CART_EMPTIED_EVENT, (): void => this.show(this.emptiedCopy))

    // No close button (checkout page) → the expiry is non-dismissible, block Escape too.
    if (this.closeButton === null) {
      this.dialog?.addEventListener('cancel', (event: Event): void => event.preventDefault())
      return
    }

    this.closeButton.addEventListener('click', (): void => this.dialog?.close())
    this.stayButton?.addEventListener('click', (): void => this.dialog?.close())
    this.dialog?.addEventListener('click', (event: MouseEvent): void => {
      if (event.target === this.dialog) this.dialog.close()
    })
  }

  private show(copy: Copy): void {
    if (this.dialog === null) return

    if (this.title !== null) this.title.textContent = copy.title === '' ? this.expiredCopy.title : copy.title
    if (this.text !== null) this.text.textContent = copy.text === '' ? this.expiredCopy.text : copy.text

    if (this.dialog.open === false) this.dialog.showModal()
  }
}

const cartExpiredModal = new CartExpiredModal()
cartExpiredModal.init()
